import type { AppDispatch } from './store'
import type { RootState } from './rootReducer'
import { HistoryActionType, undo, redo } from './history-slice'
import { updateItemFromHistory } from '../Items/Items.action'
import { openAlertContainer } from '../UI/UI.actions'
import i18n from '../Infrastructure/Translation/i18n'

// Thunk action creator for handling undo/redo operations
export const undoRedo = (isUndo: boolean) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState()
    const stack = isUndo ? state.history.undoStack : state.history.redoStack
    const lastAction = stack[stack.length - 1]

    if (!lastAction) return

    // Update stacks
    dispatch(isUndo ? undo() : redo())

    if (
      lastAction.type === HistoryActionType.ITEM_UPDATE &&
      lastAction.itemId &&
      lastAction.itemsById
    ) {
      // Get the appropriate item version
      const itemKey = isUndo ? lastAction.itemId : `${lastAction.itemId}_new`

      const item =
        lastAction.itemsById[itemKey] || lastAction.itemsById[lastAction.itemId]

      if (item) {
        dispatch(updateItemFromHistory(item))
      }
    } else if (
      lastAction.type === HistoryActionType.ITEMS_DELETE &&
      lastAction.listId &&
      lastAction.itemsById &&
      lastAction.itemIds
    ) {
      dispatch(
        openAlertContainer({
          message: isUndo
            ? i18n.t('content_undo_deletion') // can't use hooks here
            : i18n.t('content_redo_deletion'),
          alertType: 'warning',
        })
      )
    }
  }
}
